import { render } from "./GoalType.vue?vue&type=template&id=7410956f"
import script from "./GoalType.vue?vue&type=script&lang=js"
export * from "./GoalType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__